<template>
  <div class="faqs-component">
    <a-collapse accordion>
      <a-collapse-panel
        v-for="(item, index) in questions"
        :key="index"
        :header="item.question"
      >
        <p class="answer" v-html="item.answer"></p>
        <div v-if="item.link && item.link != ''" class="d-flex">
          <h3>
            <p>{{ labels.watchTheVideo }}:</p>
          </h3>
          <a-button
            type="default"
            class="play-button"
            @click="openModalVideo = true"
          >
            {{ labels.playVideo }}
            <a-icon type="play-circle" />
          </a-button>
          <a-modal
            :visible="openModalVideo"
            centered
            :closable="true"
            class="modal-video"
            :footer="null"
            @cancel="openModalVideo = false"
          >
            <iframe
              :src="item.link"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </a-modal>
        </div>
      </a-collapse-panel>
      <a-collapse-panel
        key="download-app"
        class="download-app"
        :header="labels.appDownload.title"
      >
        <h2 class="text-center">
          {{ labels.appDownload.subtitle }}
        </h2>
        <div class="d-flex justify-content-center play-buttons">
          <img
            :src="googlePlay"
            alt="Google Play"
            class="img-fluid"
            width="150"
            @click="showStore = 'google'"
            :class="{ selected: showStore === 'google' }"
          />
          <img
            :src="appleStore"
            alt="Apple Store"
            class="img-fluid"
            width="150"
            @click="showStore = 'apple'"
            :class="{ selected: showStore === 'apple' }"
          />
        </div>
        <div class="play-container" v-if="showStore === 'google'">
          <h3>{{ labels.appDownload.android }}</h3>
          <div class="step-container">
            <img :src="androidStep1" alt="Paso 1" class="step-image" />
            <img :src="androidStep2" alt="Paso 2" class="step-image" />
            <img :src="androidStep3" alt="Paso 3" class="step-image" />
            <img :src="androidStep4" alt="Paso 4" class="step-image" />
          </div>
        </div>
        <div class="play-container" v-if="showStore === 'apple'">
          <h3>{{ labels.appDownload.ios }}</h3>
          <div class="step-container">
            <img :src="iosStep1" alt="Paso 1" class="step-image" />
            <img :src="iosStep2" alt="Paso 2" class="step-image" />
            <img :src="iosStep3" alt="Paso 3" class="step-image" />
          </div>
        </div>
      </a-collapse-panel>
    </a-collapse>
  </div>
</template>
<script>
import labels from "@/utils/labels";
import { mapActions } from "vuex";
import appleStore from "@/assets/images/apple-store.png";
import googlePlay from "@/assets/images/google-play.png";
import androidStep1 from "@/assets/images/android/step-1.png";
import androidStep2 from "@/assets/images/android/step-2.png";
import androidStep3 from "@/assets/images/android/step-3.png";
import androidStep4 from "@/assets/images/android/step-4.png";
import iosStep1 from "@/assets/images/ios/step-1.png";
import iosStep2 from "@/assets/images/ios/step-2.png";
import iosStep3 from "@/assets/images/ios/step-3.png";
export default {
  name: "FAQsComponent",
  props: {},
  components: {},
  data() {
    return {
      labels: labels.faqs,
      questions: [],

      items: [],
      currentPage: 1,
      totalPages: 0,
      openModalVideo: false,
      appleStore,
      googlePlay,
      showStore: "google",
      androidStep1,
      androidStep2,
      androidStep3,
      androidStep4,
      iosStep1,
      iosStep2,
      iosStep3,
    };
  },
  methods: {
    ...mapActions({
      frequentlyAskedQuestions: "systemConfig/getFrequentlyAskedQuestions",
      loading: "systemConfig/getIsLoading",
    }),
    async getQuestions(page = 1) {
      let { data: data } = await this.frequentlyAskedQuestions(page, 10);
      this.questions = [...data];
    },
  },
  created() {
    this.getQuestions();
  },
};
</script>

<style lang="scss">
@import "~@/assets/scss/variable";

.ant-modal-close {
  color: var(--white);

  top: -10px;
  right: -10px;

  &:hover {
    color: var(--btn-bg-primary);
  }
}

.modal-video {
  .ant-modal-body {
    padding: 0;

    iframe {
      height: 300px !important;
      width: 100% !important;
    }
  }
}

.faqs-component {
  margin-top: 40px;
  @media screen and (max-width: $screen-mobile) {
    margin-top: 14px !important;
  }
  .play-button {
    background: transparent !important;
    color: var(--btn-bg-primary);
    border-color: var(--btn-bg-primary);
  }

  .ant-collapse {
    background: transparent;
    color: var(--white);

    .ant-collapse-item {
      background: transparent;

      .ant-collapse-header {
        background: var(--primary);
        font-weight: 500;
        font-size: 18px;
        color: var(--white);

        i {
          color: var(--white);
        }
      }

      .ant-collapse-content {
        background: transparent;
        color: var(--white);

        p {
          color: var(--white) !important;
        }
      }
    }
  }
}

.light {
  .faqs-component {
    margin-top: 40px;

    .ant-collapse {
      background: transparent;
      color: var(--primary);

      .ant-collapse-item {
        background: transparent;

        .ant-collapse-header {
          background: var(--white);
          font-weight: 500;
          font-size: 18px;
          color: var(--primary);

          i {
            color: var(--primary);
          }
        }

        .ant-collapse-content {
          background: transparent;
          color: var(--primary);

          p {
            color: black !important;
          }
        }
      }
    }
  }
}
.download-app {
  h2 {
    color: var(--text);
    margin-bottom: 20px;
    font-size: 24px;
    font-weight: 600;
    text-align: center;
  }

  .play-buttons {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    margin-bottom: 20px;

    img {
      cursor: pointer;
      margin: 0 10px;
      transition: transform 0.3s;
      width: 180px;
      height: auto;

      &:hover {
        transform: scale(1.05);
      }
      &.selected {
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
      }
    }
  }

  .play-container {
    text-align: center;
    font-size: 16px;
    color: var(--text);
    margin-top: 10px;
    h3 {
      margin-bottom: 20px;
      font-weight: 600;
      color: var(--text);
    }
    .step-container {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      gap: 10px;
      flex-wrap: wrap;
      .step-image {
        width: 100%;
        max-width: 240px;
        height: 500px;
        border-radius: 8px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      }
    }
  }
}
</style>
